import { useId } from 'react';

import styles from './guest-amount-input.module.css';
import { SearchSchema } from '../../../../search.schema';
import { NumberInputController, type NumberInputControllerProps } from '../number-input/number-input.controller';

type GuestAmountInputProps<T extends SearchSchema> = Omit<NumberInputControllerProps<T>, 'id'> & {
  label: string;
  subLabel: string;
};
export const GuestAmountInput = <T extends SearchSchema>({
  label,
  subLabel,
  ...numberInputControllerProps
}: GuestAmountInputProps<T>) => {
  const id = useId();

  return (
    <div className={styles.wrapper}>
      <div className={styles.labels}>
        <label className={styles.label} id={id}>
          {label}
        </label>
        <span className={styles.subLabel}>{subLabel}</span>
      </div>

      <div>
        <NumberInputController {...numberInputControllerProps} aria-labelledby={id} />
      </div>
    </div>
  );
};
